<template>
    <div>
        <div class="page-loader-wrapper" v-if="isLoading || isCombineLoader">
            <div class="loader">
                <div>
                <img src="@/assets/images/Angel_Communities_Logo.svg" width="200" height="45" alt="PayAngel" loading="lazy"/>
                <p>Please wait...</p>
                </div>
            </div>
        </div>
        <AdminHeaderComponent/>
        <SidebarComponent :loggedInUserData="currentUser" :currentOrganisation="primaryOrganization"/>
        <div @click="hideSidebar()" id="main-content" :class="[footerTypeIs,contentClass]">
            <slot></slot>
        </div>
        <AdminFooterComponent :footerType="footerTypeIs"/>
    </div>
</template>
<script>
import { mapGetters } from "vuex";
const AdminHeaderComponent = () => import('@/components/layouts/default/AdminHeaderComponent.vue');
const SidebarComponent = () => import('@/components/layouts/default/SidebarComponent.vue');
const AdminFooterComponent = () => import('@/components/layouts/default/AdminFooterComponent.vue');
export default {
    name:'DefaultLayout',
    props: {
        props : String,
    },
    components: {
        AdminHeaderComponent,
        SidebarComponent,
        AdminFooterComponent
    },computed: {
        footerTypeIs() {
            var currentfooterType = '';
            if(this.$route.name == 'cdashboard'){
                currentfooterType = 'client'
            }else{
                currentfooterType = 'admin'
            }
            return currentfooterType;
        },

        contentClass(){
            var currentcontentClass = '';
            if(this.$route.name == 'blog_list' ||  this.$route.name == 'blog_details'){
                currentcontentClass = 'blog-page'
            }else if(this.$route.name == 'typography' || this.$route.name == 'fdocuments' || this.$route.name == 'fimages' || this.$route.name == 'fmedia'){
                currentcontentClass = 'file_manager'
            }else if(this.$route.name == 'pgallery' || this.$route.name == 'ptimeline'){
                currentcontentClass = 'profilepage_1'
            }
            return currentcontentClass;
      },
      ...mapGetters(["isLoading", "isCombineLoader", "currentUser", "primaryOrganization"])
    },
    methods: {
        hideSidebar(){
            if(document.body.classList.contains('offcanvas-active')){
                document.body.classList.remove("offcanvas-active");
            }
        }
    },
}
</script>
<style scoped>

</style>